// extracted by mini-css-extract-plugin
export default {"nav":"navstyles_nav__Vkz7g","navitem":"navstyles_navitem__a4khA","navlink":"navstyles_navlink__9FZGK","navlink_after":"navstyles_navlink_after__xJcFc"};